"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _style = _interopRequireDefault(require("./style.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var IconLabel = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function IconLabel() {
    var _this;
    _classCallCheck(this, IconLabel);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, IconLabel, [].concat(args));
    _defineProperty(_this, "processUrl", function (_ref) {
      var url = _ref.url,
        history = _ref.history;
      var found = url.match(/(\/:[\w-]+\?)/g);
      if (found) {
        found.forEach(function (pattern) {
          url = url.replace(pattern, '');
        });
      }
      history.push(url);
    });
    return _this;
  }
  _inherits(IconLabel, _React$Component);
  return _createClass(IconLabel, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        item = _this$props.item,
        active = _this$props.active;
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: item.handle,
        className: (0, _classnames["default"])('nav-item', active && 'active')
      }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        render: function render(_ref2) {
          var history = _ref2.history;
          return /*#__PURE__*/_react["default"].createElement("a", {
            className: (0, _classnames["default"])('nav-link', active && 'active'),
            onClick: _this2.processUrl.bind(null, {
              url: item.url,
              history: history
            })
          }, item.render.params.icon && /*#__PURE__*/_react["default"].createElement("span", {
            className: "".concat(_style["default"].icon, " icon")
          }, /*#__PURE__*/_react["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: item.render.params.icon.viewBox
          }, /*#__PURE__*/_react["default"].createElement("g", null, item.render.params.icon.paths.map(function (p) {
            return /*#__PURE__*/_react["default"].createElement("path", {
              key: p,
              d: p
            });
          })))), /*#__PURE__*/_react["default"].createElement("span", {
            className: "secondary-nav-text"
          }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
            content: item.render.params.label
          })));
        }
      }));
    }
  }]);
}(_react["default"].Component);
_defineProperty(IconLabel, "propTypes", {
  active: _propTypes["default"].bool,
  item: _propTypes["default"].object,
  location: _propTypes["default"].object
});